module.exports = __webpack_public_path__ + "static/media/european-commission.f1951735.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/european-commission.svg
// module id = 1533
// module chunks = 0